import { render, staticRenderFns } from "./QuestionHeader.vue?vue&type=template&id=541f19aa&scoped=true"
import script from "./QuestionHeader.vue?vue&type=script&lang=js"
export * from "./QuestionHeader.vue?vue&type=script&lang=js"
import style0 from "./QuestionHeader.vue?vue&type=style&index=0&id=541f19aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f19aa",
  null
  
)

export default component.exports